$(document).ready(function () {

  new Swiper(".new-pdp-mobile-swiper", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });

  if ($("#new-pdp-images-desktop").children().length <= 4)
    $("#new-pdp-images-more-button").hide();

  let showMore = false;
  function toggleImages() {
    if (showMore) {
      $("#new-pdp-images-desktop").children().show();
      $("#new-pdp-images-more-button").find("svg").css("rotate", "180deg");
      $("#new-pdp-images-more-text").text("Show Less");
    } else {
      const images = $("#new-pdp-images-desktop").children();
      for (let index = 0; index < images.length; index++) {
        if (index > 3) {
          const element = $(images[index]);
          element.hide();
        }
      }
      $("#new-pdp-images-more-button").find("svg").css("rotate", "0deg");
      $("#new-pdp-images-more-text").text("Show More");
    }
    showMore = !showMore;
  }
  toggleImages();
  $("#new-pdp-images-more-button").click(() => toggleImages());

  $("#new-pdp-more-details").click(function (e) {
    $("#new-pdp-description-container").removeClass("max-h-[60px]");
    $("#new-pdp-description ul").css("display", "block");
    $("#new-pdp-description-container > button").css("display", "block");
    $(this).parent().hide();
  });
  $("#new-pdp-less-details").click(function (e) {
    $("#new-pdp-description-container").addClass("max-h-[60px]");
    $("#new-pdp-description ul").css("display", "none");
    $("#new-pdp-description-container > button").css("display", "none");
    $("#new-pdp-more-details").parent().show();
  });

  $("#new-pdp-description ul").css("display", "none");
  $("#new-pdp-description-container > button").css("display", "none");

  $("#new-pdp-description ul li")
    .css("fontWeight", "bold")
    .css("color", "#000000")
    .css("padding-bottom", "10px")
    .css("padding-top", "10px");
  $("#new-pdp-description ul li strong:first-child")
    .css("color", "#6f7075")
    .css("fontWeight", "normal")
    .css("width", "96px")
    .css("display", "inline-block");
  $("#new-pdp-description ul li").css("border-bottom", "1px dashed #e4e9f1");
  $("#new-pdp-description ul li:last-child").css("border-bottom", "none");

  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $("#new-pdp-subheader").show();
    } else {
      $("#new-pdp-subheader").hide();
    }
  });

  // product-features-carousel
  let productFeaturesSwiperInstance;

  function productFeaturesToggleSwiper() {
    const productFeaturesSwiper = document.querySelector(
      ".product-features-swiper"
    );
    if (!productFeaturesSwiper) return;

    if (productFeaturesSwiperInstance) {
      productFeaturesSwiperInstance.destroy(true, true);
      productFeaturesSwiperInstance = null;
    }

    if (window.innerWidth > 768) {
      productFeaturesSwiperInstance = new Swiper(".product-features-swiper", {
        slidesPerView: "auto",
        spaceBetween: 24,
        pagination: {
          el: ".swiper-product-features-pagination",
          clickable: true,
        },
      });
    }
  }

  // Initial check
  productFeaturesToggleSwiper();

  // Re-check on window resize
  window.addEventListener("resize", productFeaturesToggleSwiper);
  // End product-features-carousel


  // product-reviews-carousel
  new Swiper(".product-reviews-swiper", {
    slidesPerView: 1,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 2000
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });

  new Swiper(".product-reviews-swiper-mobile", {
    slidesPerView: 1,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 2000
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });



  $(".product-lens-info-title").each(function () {
    var me = $(this),
      t = me.text().split(" ");
    me.html(
      '<span class="text-[#2b6ada] ">' + t.shift() + "</span> " + t.join(" ")
    );
  });

  // Okendo
  $(".new-pdp-okendo-main-section .oke-sr-count-number").hide();
  $(".new-pdp-okendo-main-section .oke-sr-label-text").hide();
  const totalReviewElement = $(
    ".new-pdp-okendo-main-section .oke-sr-total-text"
  );
  const totalReviewMatch = totalReviewElement.text().match(/\((\d+)\sReview\)/);
  if (totalReviewMatch) {
    const totalReview = totalReviewMatch[1];
    totalReviewElement.text(totalReview);
  }
  setTimeout(() => {
    $.ajax({
      url: "/pages/fit-guide",
      type: "GET",
      success: function (data) {
        var f = 0;
        var f_found = false;
        for (f = 0; f < ccFitGuide.length; f++) {
          if (!f_found) {
            var checkGuide = $(data).find(
              'div[data-html="' + ccFitGuide[f] + '"]'
            );
            var img = checkGuide
              .find(".fit-guide__image-container img:first-child")
              .css("padding-left", "16px")
              .css("padding-right", "16px");
            var spec = checkGuide.find(".fit-guide__frame-specs");
            if (checkGuide.length > 0) {
              f_found = true;
              $(".new-pdp-fit-information").append(img).append(spec);
              $(".content-wrapper").prepend(
                $("#new-pdp-fit-information-modal")
              );
            }
          }
        }
      },
    });
  }, 1000);

  function hideFitInformationModal() {
    $(".new-pdp-fit-information-modal").addClass("hidden");
    $(".new-pdp-fit-information-modal .modal-bg")
      .removeClass("opacity-100")
      .addClass("opacity-0");
    $(".new-pdp-fit-information-modal .modal-container")
      .removeClass("opacity-100 translate-y-0")
      .addClass("opacity-0 translate-y-4");
  }
  function showFitInformationModal() {
    $(".new-pdp-fit-information-modal").removeClass("hidden");
    $(".new-pdp-fit-information-modal .modal-bg")
      .removeClass("opacity-0")
      .addClass("opacity-100");
    $(".new-pdp-fit-information-modal .modal-container")
      .removeClass("opacity-0 translate-y-4")
      .addClass("opacity-100 translate-y-0");
  }
  $("#new-pdp-fit-information-btn").click(() => {
    showFitInformationModal();
  });

  $(".new-pdp-fit-information-modal .modal-close").click(() =>
    hideFitInformationModal()
  );
  $(window).click(function (event) {
    if ($(event.target).is(".modal-bg")) {
      hideFitInformationModal();
    }
  });

  const colorsElement = document.querySelectorAll("#new-pdp-colors-list a");
  let colorsMoreIsOpen = false;

  $(window).on("resize", function () {
    renderColorsList();
  });

  function renderColorsList() {
    console.log(colorsElement?.length);
    
    const colorwidgetWidth = 90;
    const count =
      Math.floor(($("#new-pdp-colors-list-container").width() + 10) / colorwidgetWidth);
    $("#new-pdp-colors-list").css(
      "grid-template-columns",
      `repeat(${count}, minmax(0, 1fr))`
    );
    if (colorsMoreIsOpen) return;

    for (let i = 0; i < colorsElement.length; i++) {
      if (i >= count) {
        $(colorsElement[i]).hide();
      } else {
        $(colorsElement[i]).show();
      }
    }

    if (colorsElement?.length > count) {
      $("#new-pdp-colors-list button").text(`+${colorsElement.length - count}`);
    } else {
      $("#new-pdp-colors-list button").hide();
    }
  }
  renderColorsList();

  $("#new-pdp-colors-list .expand-btn").click(function () {
    $(colorsElement).show();
    $(this).hide();
    colorsMoreIsOpen = true;
  });

  document.getElementById("new-pdp-images-desktop").onclick = function (event) {
    event = event || window.event;
    var target = event.target || event.srcElement,
      link = target.src ? target.parentNode : target,
      options = { index: link, event: event },
      links = this.getElementsByTagName("a");
    blueimp.Gallery(links, options);
  };

  const checkTheLookDom = document.getElementById("check_the_look");
  if (checkTheLookDom)
    document.getElementById("check_the_look").onclick = function (event) {
      event = event || window.event;
      var target = event.target || event.srcElement,
        link = target.src ? target.parentNode : target,
        options = { index: link, event: event },
        links = this.getElementsByTagName("a");
      blueimp.Gallery(links, options);
    };

  $(".new-pdp-variant-item").click(function () {
    const variantId = $(this).attr("data-variant-id");
    const variantInventoryQuantity = $(this).attr("data-variant-inventory_quantity");

    const activeClass =
      "bg-gradient-to-r to-[#18369C] from-[#31C3E8] [&_.lens-checkbox]:bg-[#204cb2] [&_.lens-checkbox]:border-[#204cb2]";
    const inactiveClass = "bg-[#e2e3ea] [&_.lens-checkbox]:border-[#e2e3ea]";
    $(this)
      .addClass(activeClass)
      .removeClass(inactiveClass)
      .siblings()
      .removeClass(activeClass)
      .addClass(inactiveClass);
    
    $(`.new-pdp-main-sidebar [data-variant-price-container=${variantId}]`).removeClass('hidden').siblings().addClass('hidden');
    if (variantInventoryQuantity == 0) {
      $("#new_pdp_email_me_btn").removeClass('hidden');
      $("#new_pdp_add_to_cart_container").addClass('hidden');
      $("#new_pdp_email_me_btn").attr('data-variant-id', variantId);
    } else {
      $("#new_pdp_email_me_btn").addClass('hidden');
      $("#new_pdp_add_to_cart_container").removeClass('hidden');
      $("#new_pdp_add_to_cart_form").find('input[name="id"]').val(variantId);
      $("#new_pdp_add_to_cart_form").find('button[name="cart-btn"]').attr("cc-compare-flow", variantId);
      if ($(this).attr("data-variant-compare-price")) {
        $("#new_pdp_add_to_cart_form").find('button[name="cart-btn"]').attr("cc-compare", $(this).attr("data-variant-compare-price"));
      }
      $("#new-pdp-variant-price-cart").text($(this).attr("data-variant-price"));
    }
  });

  $(".email-me-btn").click(function() {
    const variantId = $(this).parent().attr('data-variant-id');
    BISPopover.show({
      variantId: variantId
    });
  })
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.style.overflow = "auto";
});
